export default{
  
    showLongDescription:"Show Long Description",
    hideLongDescription:"Hide Long Description"
    
    }
    